export default "__VITE_ASSET__QrjaF1el__"